const MoneyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
  >
    <path
      d="M17 5C19.3734 5 21.6934 5.70408 23.6668 7.02266C25.6402 8.34121 27.1789 10.2148 28.0872 12.4074C28.9954 14.6002 29.2322 17.0137 28.7692 19.3414C28.3061 21.6691 27.1637 23.8075 25.4856 25.4856C23.8075 27.1637 21.6691 28.3061 19.3414 28.7692C17.0137 29.2322 14.6002 28.9954 12.4074 28.0872C10.2148 27.1789 8.34121 25.6402 7.02266 23.6668C5.70408 21.6934 5 19.3734 5 17C5 16.3373 5.53726 15.8 6.2 15.8C6.86275 15.8 7.40001 16.3373 7.40001 17C7.40001 18.8987 7.96351 20.7545 9.01837 22.3332C10.0732 23.9119 11.5721 25.1422 13.3262 25.8688C15.0803 26.5954 17.0106 26.7864 18.8727 26.4161C20.7349 26.0457 22.4461 25.1313 23.7887 23.7887C25.1313 22.4461 26.0457 20.7349 26.4161 18.8727C26.7864 17.0106 26.5954 15.0803 25.8688 13.3262C25.1422 11.5721 23.9119 10.0732 22.3332 9.01837C20.7552 7.96394 18.9003 7.40047 17.0024 7.40001C14.2936 7.41076 11.6937 8.468 9.74611 10.3508L9.09689 11H12.2C12.8628 11 13.4 11.5373 13.4 12.2C13.4 12.8628 12.8628 13.4 12.2 13.4H6.2C5.53726 13.4 5 12.8628 5 12.2V6.2C5 5.53726 5.53726 5 6.2 5C6.86275 5 7.40001 5.53726 7.40001 6.2V9.30314L8.06329 8.63985L8.53556 8.20391C10.8709 6.15444 13.8743 5.01178 16.9953 5H17Z"
      fill="#156DF2"
    />
    <path
      d="M17 12V22M19.5 13.5H15.75C15.2859 13.5 14.8408 13.6844 14.5126 14.0126C14.1844 14.3408 14 14.7859 14 15.25C14 15.7141 14.1844 16.1592 14.5126 16.4874C14.8408 16.8156 15.2859 17 15.75 17H18.25C18.7141 17 19.1592 17.1844 19.4874 17.5126C19.8156 17.8408 20 18.2859 20 18.75C20 19.2141 19.8156 19.6592 19.4874 19.9874C19.1592 20.3156 18.7141 20.5 18.25 20.5H14"
      stroke="#156DF2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default MoneyIcon;
